import { action } from 'typesafe-actions';
import { IAppConfig, ICoverageModel, InsuranceType, UiStatus } from '../type';
import * as actionKeys from './action-keys';

export const setResources = (resources: { [key: string]: string }) => action(actionKeys.setResources, resources);
export const setUiStatus = (uiStatus: UiStatus) => action(actionKeys.setUiStatus, uiStatus);
export const setConfig = (config: IAppConfig) => action(actionKeys.setConfig, config);
export const setFormStep = (formStep: number) => action(actionKeys.setFormStep, formStep);
export const setUpdatingCoverage = (objectCoverageId: number | null) =>
    action(actionKeys.setUpdatingCoverage, objectCoverageId);
export const setDataPolicyContentBlock = (block: string) => action(actionKeys.setDataPolicyContentBlock, block);
export const setTerminationFeeContentBlock = (block: string) => action(actionKeys.setTerminationFeeContentBlock, block);

export const setModel = (model: ICoverageModel) => action(actionKeys.setModel, model);
export const updateModel = (model: ICoverageModel) => action(actionKeys.updateModel, model);
export const setInsuranceShouldTerminate = (insuranceType: InsuranceType, shouldTerminate: boolean) =>
    action(actionKeys.setInsuranceShouldTerminate, {
        insuranceType,
        shouldTerminate
    });
export const setHasContentInsurance = (hasContentInsurance: boolean) =>
    action(actionKeys.setHasContentInsurance, {
        hasContentInsurance
    });
export const setShowNewInsuranceStartDateInputType = (insuranceType: InsuranceType | null) =>
    action(actionKeys.setShowNewInsuranceStartDateInputType, {
        insuranceType
    });
export const setInsuranceTerminateDate = (insuranceType: InsuranceType, terminationDate: string) =>
    action(actionKeys.setInsuranceTerminateDate, { insuranceType, terminationDate });
export const setInsuranceCompany = (
    insuranceType: InsuranceType,
    insuranceCompanyId: string,
    insuranceCompanyName: string
) => action(actionKeys.setInsuranceCompany, { insuranceType, insuranceCompanyId, insuranceCompanyName });
export const setInsuranceNumber = (insuranceType: InsuranceType, insuranceNumber: string) =>
    action(actionKeys.setInsuranceNumber, { insuranceType, insuranceNumber });
export const setNewInsuranceStartDate = (startDate: string) => action(actionKeys.setNewInsuranceStartDate, startDate);

export const setCustomerName = (name: string) => action(actionKeys.setCustomerName, name);
export const setCustomerCpr = (cpr: string) => action(actionKeys.setCustomerCpr, cpr);
export const setCustomerAddress = (address: string) => action(actionKeys.setCustomerAddress, address);
export const setCustomerMobile = (mobile: string) => action(actionKeys.setCustomerMobile, mobile);
export const setCustomerEmail = (email: string) => action(actionKeys.setCustomerEmail, email);
export const checkSkybrud = (check: boolean) => action(actionKeys.checkSkybrud, check);
export const checkSkader = (check: boolean) => action(actionKeys.checkSkader, check);
export const checkGaeld = (check: boolean) => action(actionKeys.checkGaeld, check);

export const setRegNum = (regNum: string) => action(actionKeys.setRegNum, regNum);
export const setAccountNum = (accountNum: string) => action(actionKeys.setAccountNum, accountNum);
export const setIsSomeoneElseAccount = (isSomeoneElseAccount: boolean) =>
    action(actionKeys.setIsSomeoneElseAccount, isSomeoneElseAccount);
export const setAccountHolderCprNumber = (accountHolderCprNumber: string) =>
    action(actionKeys.setAccountHolderCprNumber, accountHolderCprNumber);
export const setAgreeTermsOfPurchase = (agreeTermsOfPurchase: boolean) =>
    action(actionKeys.setAgreeTermsOfPurchase, agreeTermsOfPurchase);
export const setAgreeObtainInfo = (agreeObtainInfo: boolean) => action(actionKeys.setAgreeObtainInfo, agreeObtainInfo);
export const setIsPaymentValid = (isPaymentValid: boolean) => action(actionKeys.setIsPaymentValid, isPaymentValid);
